module.exports = __webpack_public_path__ + "img/title-3.37a57334.png";